/**
 *   中国地图经纬度
 */
export default {
    江苏省海门: [
        121.15,
        31.89
    ],
    内蒙古自治区鄂尔多斯: [
        109.781327,
        39.608266
    ],
    山东省招远: [
        120.38,
        37.35
    ],
    浙江省舟山: [
        122.207216,
        29.985295
    ],
    黑龙江省齐齐哈尔: [
        123.97,
        47.33
    ],
    江苏省盐城: [
        120.13,
        33.38
    ],
    内蒙古自治区赤峰: [
        118.87,
        42.28
    ],
    山东省青岛: [
        120.33,
        36.07
    ],
    山东省乳山: [
        121.52,
        36.89
    ],
    甘肃省金昌: [
        102.188043,
        38.520089
    ],
    福建省泉州: [
        118.58,
        24.93
    ],
    山东省莱西: [
        120.53,
        36.86
    ],
    山东省日照: [
        119.46,
        35.42
    ],
    山东省胶南: [
        119.97,
        35.88
    ],
    江苏省南通: [
        121.05,
        32.08
    ],
    西藏自治区拉萨: [
        91.11,
        29.97
    ],
    广东省云浮: [
        112.02,
        22.93
    ],
    广东省梅州: [
        116.1,
        24.55
    ],
    山东省文登: [
        122.05,
        37.2
    ],
    上海: [
        121.48,
        31.22
    ],
    四川省攀枝花: [
        101.718637,
        26.582347
    ],
    山东省威海: [
        122.1,
        37.5
    ],
    河北省承德: [
        117.93,
        40.97
    ],
    福建省厦门: [
        118.1,
        24.46
    ],
    广东省汕尾: [
        115.375279,
        22.786211
    ],
    广东省潮州: [
        116.63,
        23.68
    ],
    辽宁省丹东: [
        124.37,
        40.13
    ],
    江苏省太仓: [
        121.1,
        31.45
    ],
    云南省曲靖: [
        103.79,
        25.51
    ],
    山东省烟台: [
        121.39,
        37.52
    ],
    辽宁省瓦房店: [
        121.979603,
        39.627114
    ],
    山东省即墨: [
        120.45,
        36.38
    ],
    辽宁省抚顺: [
        123.97,
        41.97
    ],
    云南省玉溪: [
        102.52,
        24.35
    ],
    河北省张家口: [
        114.87,
        40.82
    ],
    山西省: [
        113.57,
        37.85
    ],
    山东省莱州: [
        119.942327,
        37.177017
    ],
    浙江省湖州: [
        120.1,
        30.86
    ],
    广东省汕头: [
        116.69,
        23.39
    ],
    江苏省昆山: [
        120.95,
        31.39
    ],
    浙江省宁波: [
        121.56,
        29.86
    ],
    广东省湛江: [
        110.359377,
        21.270708
    ],
    广东省揭阳: [
        116.35,
        23.55
    ],
    山东省荣成: [
        122.41,
        37.16
    ],
    江苏省连云港: [
        119.16,
        34.59
    ],
    辽宁省葫芦岛: [
        120.836932,
        40.711052
    ],
    江苏省常熟: [
        120.74,
        31.64
    ],
    广东省东莞: [
        113.75,
        23.04
    ],
    广东省河源: [
        114.68,
        23.73
    ],
    江苏省淮安: [
        119.15,
        33.5
    ],
    江苏省泰州: [
        119.9,
        32.49
    ],
    广西壮族自治区南宁: [
        108.33,
        22.84
    ],
    辽宁省营口: [
        122.18,
        40.65
    ],
    广东省惠州: [
        114.4,
        23.09
    ],
    江苏省江阴: [
        120.26,
        31.91
    ],
    山东省蓬莱: [
        120.75,
        37.8
    ],
    广东省韶关: [
        113.62,
        24.84
    ],
    甘肃省嘉峪关: [
        98.289152,
        39.77313
    ],
    广东省广州: [
        113.23,
        23.16
    ],
    陕西省延安: [
        109.47,
        36.6
    ],
    山西省太原: [
        112.53,
        37.87
    ],
    广东省清远: [
        113.01,
        23.7
    ],
    广东省中山: [
        113.38,
        22.52
    ],
    云南省昆明: [
        102.73,
        25.04
    ],
    山东省寿光: [
        118.73,
        36.86
    ],
    辽宁省盘锦: [
        122.070714,
        41.119997
    ],
    山西省长治: [
        113.08,
        36.18
    ],
    广东省深圳: [
        114.07,
        22.62
    ],
    广东省珠海: [
        113.52,
        22.3
    ],
    江苏省宿迁: [
        118.3,
        33.96
    ],
    陕西省咸阳: [
        108.72,
        34.36
    ],
    陕西省铜川: [
        109.11,
        35.09
    ],
    山东省: [
        119.97,
        36.77
    ],
    广东省佛山: [
        113.11,
        23.05
    ],
    海南省海口: [
        110.35,
        20.02
    ],
    广东省江门: [
        113.06,
        22.61
    ],
    山东省章丘: [
        117.53,
        36.72
    ],
    广东省肇庆: [
        112.44,
        23.05
    ],
    辽宁省大连: [
        121.62,
        38.92
    ],
    山西省临汾: [
        111.5,
        36.08
    ],
    江苏省吴江: [
        120.63,
        31.16
    ],
    宁夏回族自治区石嘴山: [
        106.39,
        39.04
    ],
    山东新泰:[
        117.45,
        35.54
    ],
    辽宁省沈阳: [
        123.38,
        41.8
    ],
    江苏省苏州: [
        120.62,
        31.32
    ],
    广东省茂名: [
        110.88,
        21.68
    ],
    浙江省嘉兴: [
        120.76,
        30.77
    ],
    吉林省长春: [
        125.35,
        43.88
    ],
    山东省胶州: [
        120.03336,
        36.264622
    ],
    宁夏回族自治区银川: [
        106.27,
        38.47
    ],
    江苏省张家港: [
        120.555821,
        31.875428
    ],
    河南省三门峡: [
        111.19,
        34.76
    ],
    辽宁省锦州: [
        121.15,
        41.13
    ],
    江西省南昌: [
        115.89,
        28.68
    ],
    广西壮族自治区柳州: [
        109.4,
        24.33
    ],
    海南省三亚: [
        109.511909,
        18.252847
    ],
    四川省自贡: [
        104.778442,
        29.33903
    ],
    四川省乐山: [
        103.761263,
        29.582024
    ],
    吉林: [
        126.57,
        43.87
    ],
    广东省阳江: [
        111.95,
        21.85
    ],
    四川省泸州: [
        105.39,
        28.91
    ],
    青海省西宁: [
        101.74,
        36.56
    ],
    四川省宜宾: [
        104.56,
        29.77
    ],
    内蒙古自治区呼和浩特: [
        111.65,
        40.82
    ],
    四川省成都: [
        104.06,
        30.67
    ],
    山西省大同: [
        113.3,
        40.12
    ],
    江苏省镇江: [
        119.44,
        32.2
    ],
    广西壮族自治区区桂林: [
        110.28,
        25.29
    ],
    河北省张家界: [
        110.479191,
        29.117096
    ],
    江苏省宜兴: [
        119.82,
        31.36
    ],
    广西壮族自治区北海: [
        109.12,
        21.49
    ],
    陕西省西安: [
        108.95,
        34.27
    ],
    江苏省金坛: [
        119.56,
        31.74
    ],
    山东省东营: [
        118.49,
        37.46
    ],
    牡丹江: [
        129.58,
        44.6
    ],
    贵州省遵义: [
        106.9,
        27.7
    ],
    浙江省绍兴: [
        120.58,
        30.01
    ],
    江苏省扬州: [
        119.42,
        32.39
    ],
    江苏省常州: [
        119.95,
        31.79
    ],
    山东省潍坊: [
        119.1,
        36.62
    ],
    重庆: [
        106.54,
        29.59
    ],
    浙江省台州: [
        121.420757,
        28.656386
    ],
    江苏省南京: [
        118.78,
        32.04
    ],
    山东省滨州: [
        118.03,
        37.36
    ],
    贵州省贵阳: [
        106.71,
        26.57
    ],
    江苏省无锡: [
        120.29,
        31.59
    ],
    辽宁省本溪: [
        123.73,
        41.3
    ],
    新疆维吾尔自治区克拉玛依: [
        84.77,
        45.59
    ],
    陕西省渭南: [
        109.5,
        34.52
    ],
    安徽省马鞍山: [
        118.48,
        31.56
    ],
    陕西省宝鸡: [
        107.15,
        34.38
    ],
    河南省焦作: [
        113.21,
        35.24
    ],
    江苏省句容: [
        119.16,
        31.95
    ],
    北京: [
        116.46,
        39.92
    ],
    江苏省徐州: [
        117.2,
        34.26
    ],
    河北省衡水: [
        115.72,
        37.72
    ],
    内蒙古自治区包头: [
        110,
        40.58
    ],
    四川省绵阳: [
        104.73,
        31.48
    ],
    新疆维吾尔自治区乌鲁木齐: [
        87.68,
        43.77
    ],
    山东省枣庄: [
        117.57,
        34.86
    ],
    浙江省杭州: [
        120.19,
        30.26
    ],
    山东省淄博: [
        118.05,
        36.78
    ],
    辽宁省鞍山: [
        122.85,
        41.12
    ],
    江苏省: [
        119.48,
        31.43
    ],
    新疆维吾尔自治区库尔勒: [
        86.06,
        41.68
    ],
    河南省安阳: [
        114.35,
        36.1
    ],
    河南省开封: [
        114.35,
        34.79
    ],
    山东省济南: [
        117,
        36.65
    ],
    四川省德阳: [
        104.37,
        31.13
    ],
    浙江省温州: [
        120.65,
        28.01
    ],
    广东省九江: [
        115.97,
        29.71
    ],
    河北省邯郸: [
        114.47,
        36.6
    ],
    浙江省临安: [
        119.72,
        30.23
    ],
    甘肃省兰州: [
        103.73,
        36.03
    ],
    河北省沧州: [
        116.83,
        38.33
    ],
    山东省临沂: [
        118.35,
        35.05
    ],
    四川省南充: [
        106.110698,
        30.837793
    ],
    河北省天津: [
        117.2,
        39.13
    ],
    浙江省富阳: [
        119.95,
        30.07
    ],
    山东省泰安: [
        117.13,
        36.18
    ],
    浙江省诸暨: [
        120.23,
        29.71
    ],
    河南省郑州: [
        113.65,
        34.76
    ],
    黑龙江省哈尔滨: [
        126.63,
        45.75
    ],
    山西省聊城: [
        115.97,
        36.45
    ],
    安徽省铜陵:[
        117.42,
        30.45
    ],
    安徽省芜湖: [
        118.38,
        31.33
    ],
    河北省唐山: [
        118.02,
        39.63
    ],
    河南省平顶山: [
        113.29,
        33.75
    ],
    河北省邢台: [
        114.48,
        37.05
    ],
    山东省德州: [
        116.29,
        37.45
    ],
    山东省济宁: [
        116.59,
        35.38
    ],
    湖北省荆州: [
        112.239741,
        30.335165
    ],
    湖北省宜昌: [
        111.3,
        30.7
    ],
    浙江省义乌: [
        120.06,
        29.32
    ],
    浙江省丽水: [
        119.92,
        28.45
    ],
    河南省洛阳: [
        112.44,
        34.7
    ],
    河北省秦皇岛: [
        119.57,
        39.95
    ],
    湖南省株洲: [
        113.16,
        27.83
    ],
    河北省石家庄: [
        114.48,
        38.03
    ],
    山东省莱芜: [
        117.67,
        36.19
    ],
    湖南省常德: [
        111.69,
        29.05
    ],
    河北省保定: [
        115.48,
        38.85
    ],
    湖南省湘潭: [
        112.91,
        27.87
    ],
    浙江省金华: [
        119.64,
        29.12
    ],
    湖南省岳阳: [
        113.09,
        29.37
    ],
    湖南省长沙: [
        113,
        28.21
    ],
    浙江省衢州: [
        118.88,
        28.97
    ],
    河北省廊坊: [
        116.7,
        39.53
    ],
    山东省菏泽: [
        115.480656,
        35.23375
    ],
    安徽省合肥: [
        117.27,
        31.86
    ],
    湖北省武汉: [
        114.31,
        30.52
    ],
    黑龙江省大庆: [
        125.03,
        46.58
    ]
}